export const isExternalElement = (e) => {
    // TODO : 효과적으로 관리할 수 있는 방안 모색
    return e.target.localName === "html" || checkSearchForm(e);
};

export const checkElementClassName = (item) => {
    const externalElementList = ["EmojiPickerReact", "MuiDialog-root", "MuiPopover-root", "MuiAutocomplete-popper"];

    if (!item || typeof item.className === "object") return false;

    const isExternalElement = externalElementList.filter((e) => item.className?.includes(e)).length > 0;

    return isExternalElement;
};

// Case 1 : List > 검색 영역
function checkSearchForm(e) {
    // console.log("e", e);
    const path = e.composedPath();

    return path && path.length && path.filter((item) => checkElementClassName(item)).length > 0;
}
